export { default as Spinner } from './src/spinner';
